export default __webpack_public_path__ + "static/media/PJL05.7929baef.png";